<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">

    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'TIPORESPALDO.LBL_CODCAT' | translate }}</label>
          <div *ngIf="!respaldoCategoria">
            <input type="text" pInputText id="codigo"
                   name="nomCodigo"
                   autocomplete="off"
                   formControlName="codigo" codigos-reactive
                   (blur)="validarCodigo()"
                   [maxlength]="6"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
              {{ 'TIPORESPALDO.LBL_CODCAT' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
          <div *ngIf="respaldoCategoria && respaldoCategoria.idTipoRespaldoCategoria">
            <label class="falso-combo-texto">{{respaldoCategoria.codigo}}</label>
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'LBL_NOMBRE' | translate }}</label>
          <input type="text" pInputText id="nombre"
                 name="nomNombre"
                 autocomplete="off"
                 formControlName="nombre" capitalize-reactive
                 [maxlength]="100"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
            {{ 'LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-3 lg:col-3 ">
        <p-checkbox label="{{ 'TIPORESPALDO.LBL_INDINEGOCIO' | translate}}" binary="true"
                    id="indicadorNegocio"
                    name="nomIndicadorNegocio"
                    formControlName="indicadorNegocio"></p-checkbox>
      </div>
      <div class="col-12 md:col-3 lg:col-3 ">
        <p-checkbox label="{{ 'TIPORESPALDO.LBL_REQSUBCAT' | translate}}" binary="true"
                    id="indicadorSubcategoria"
                    name="nomIndicadorSubcategoria"
                    formControlName="indicadorSubcategoria"></p-checkbox>
      </div>
      <div class="col-12 md:col-3 lg:col-3 ">
        <p-checkbox label="{{ 'TIPORESPALDO.LBL_MANEJADJUNTO' | translate}}" binary="true"
                    id="indicadorManejaAdjunto"
                    name="nomIndicadorManejaAdjunto"
                    formControlName="indicadorManejaAdjunto" (onChange)="validarIndicadorManejaAdjunto(f.indicadorManejaAdjunto.value, f.indicadorSubcategoria.value)"></p-checkbox>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                    id="indicadorHabilitado"
                    name="nomIndicador"
                    formControlName="indicadorHabilitado"></p-checkbox>
      </div>
    </div>

    <div class="grid form-footer-buttons" *ngIf="respaldoCategoria">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <button icon="fa fa-plus" label="{{'BTN_ACTUALIZAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons" *ngIf="!respaldoCategoria">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6 md:col-offset-6 lg:col-offset-6">
      <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             (input)="dt.filterGlobal($event.target.value, 'contains')"
             [(ngModel)]="busqueda" (change)="setBusqueda()">
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="lisTipoRespaldoCategoria" selectionMode="single" dataKey="nombre"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.nombre}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorNegocio" binary="true" (click)="habilitar(row, true)"></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorManejaAdjunto" binary="true" (click)="habilitar(row, false)"></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton
                        (click)="editar(row)"></button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-eye" data-toggle="tooltip"
                        title="{{'BTN_VISUALIZAR' | translate}}" pButton
                        (click)="visualizar(row)"></button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-plus-square" data-toggle="tooltip"
                        title="{{'TIPORESPALDO.LBL_AGRSUBCAT' | translate}}" pButton
                        (click)="agregarSubcategoria(row)"
                        *ngIf="row.indicadorSubcategoria"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>
<p-confirmDialog #cd key="categoria">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
